<template>
    <div class="marginCenter">
        <div class="header flex-xCenter marginBom38">
            <el-tabs v-model="params.categoryId" @tab-click="change">
                <el-tab-pane class="pr" :name="item.categoryId+''" v-for="(item, index) in categoryList" :key="index">
                    <div slot="label">
                        {{ item.categoryName }}
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="marginBom30">
            <el-input v-model="deptSearchName" @input="deptSeach" placeholder="请输入科室名称搜索"></el-input>
        </div>
        <div class="content flex">
            <div class="left">
                <div><img src="@/assets/images/dept1.png" alt=""></div>
                <div><img src="@/assets/images/dept2.png" alt=""></div>
            </div>
            <div class="right">
                <div class="item fl flex-center fsize20" v-for="(item,index) in filterList" :key="index" @click="$router.push({path:'/specialist/detail',query:item})">{{ item.specialtyName }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import {trainSpecialtyCategory, trainSpecialty} from '@/utils/api'
export default {
    data() {
        return {
            params:{
                categoryId: 0,
            },
            categoryList: [
                {
                    categoryName: "全部学科",
                    categoryId: 0,
                },
            ],
            deptSearchName:"",
            tspecialtyList:[],
            filterList:[]
        }
    },
    created(){
        trainSpecialtyCategory().then(res=>{
            if(res.code==200){
                this.categoryList=this.categoryList.concat(res.data)
            }
        })
        this.search()
    },
    methods:{
        change(){
            this.deptSearchName=""
            this.search()
        },
        search(){
            trainSpecialty(this.params.categoryId==0?{}:this.params).then(res=>{
                if(res.code==200){
                    this.tspecialtyList=res.data
                    this.filterList=res.data
                }
            })
        },
        deptSeach(val){
            if(val){
                this.filterList=this.tspecialtyList.filter(item=>item.specialtyName.indexOf(val)!=-1)
            }else{
                this.filterList=this.tspecialtyList
            }
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__item {
    font-size: 28px !important;
  }
.content{
    &>.left{
        width: 200px;
        margin-right: 54px;
        &>div:nth-child(1){
            margin-bottom: 34px;
        }
        img{
            height: 254px;
            width: 200px;
        }
    }
    &>.right{
        flex-grow: 1;
        flex-wrap: wrap;
        &>.item{
            width: 20%;
            margin-right: 6.66%;
            margin-bottom: 3.59%;
            height: 62px;
            box-sizing: border-box;
            background: linear-gradient(139deg, #fff 0%, #CED8FF 100%);
            border-radius: 4px;
            &:hover{
                cursor: pointer;
                color: white;
                border-color: #2D53C8 !important;
                background: linear-gradient(139deg, #7AAAFF 0%, #2D53C8 100%);
            }
        }
        &>.item:nth-child(4n+0){
            margin-right: 0 !important;
        }
    }
}
</style>